import Vue from 'vue'
import Vuex from 'vuex'
import AppModule from './app'
import UserModule from '@/modules/user/_store'
import SuccessRate from '@/modules/success-rate/_store'
import Notifications from '@/modules/notifications/_store'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app: AppModule,
    user: UserModule,
    'success-rate': SuccessRate,
    notifications: Notifications
  }
})
